"use client";

import { useState } from 'react';

interface FAQItem {
    question: string;
    answer: string;
}

const faqs: FAQItem[] = [
    {
        question: "What is the check-in and check-out time?",
        answer: "Check-in is at 4:00 PM and check-out is at 11:00 AM. Early check-in or late check-out may be available upon request, subject to availability."
    },
    {
        question: "How many guests can the cabin accommodate?",
        answer: "The cabin comfortably accommodates up to 12 guests with 4 bedrooms. We can accommodate extra guests for an additional fee of $50 per person per night."
    },
    {
        question: "Are pets allowed?",
        answer: "Yes! We welcome up to 2 pets for a fee of $75 per pet. Please ensure your pets are well-behaved and supervised at all times. Pets must not be left alone in the cabin."
    },
    {
        question: "Is the cabin suitable for children?",
        answer: "Absolutely! The cabin is very family-friendly with plenty of space for kids to play both inside and out. The game room and large yard are perfect for families. We recommend supervising children near the fire pit area."
    },
    {
        question: "What should I bring?",
        answer: "We provide linens, towels, and basic toiletries. You may want to bring personal items, groceries, outdoor gear for activities, and any special equipment for your planned adventures. In winter, bring warm clothes and snow gear!"
    },
    {
        question: "Is there WiFi? How fast is it?",
        answer: "Yes, we have high-speed WiFi with 100+ Mbps download speed, perfect for streaming, video calls, or remote work."
    },
    {
        question: "How far is the cabin from Seattle?",
        answer: "The cabin is approximately 90 minutes from Seattle, making it an easy weekend getaway from the city."
    },
    {
        question: "What's the cancellation policy?",
        answer: "Free cancellation up to 14 days before check-in. Cancellations within 14 days receive a 50% refund. No refunds for cancellations within 7 days of check-in."
    },
    {
        question: "Are there grocery stores nearby?",
        answer: "Yes, there are grocery stores in Cle Elum, about 15 minutes away. We recommend stocking up before arriving, but you'll have access to essentials nearby."
    },
    {
        question: "What activities are available in winter vs summer?",
        answer: "Summer: Hiking, mountain biking, lake swimming, fishing, and kayaking. Winter: Skiing/snowboarding at Snoqualmie Pass (30 min), snowshoeing, and cozy cabin time by the fire."
    },
    {
        question: "Is the property private?",
        answer: "Yes! The cabin sits on 1.5 acres of private property surrounded by nature, offering complete privacy and tranquility."
    },
    {
        question: "Is there cell phone service?",
        answer: "Cell service can be spotty depending on your carrier. Verizon and AT&T typically have decent coverage. WiFi calling is available via our high-speed internet."
    }
];

export default function FAQSection() {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleFAQ = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="w-full px-4 md:px-6 py-10 md:py-15">
            <h2 className="font-bold text-3xl sm:text-4xl md:text-5xl text-center mb-8 md:mb-12">
                Frequently Asked Questions
            </h2>

            <div className="max-w-4xl mx-auto space-y-4">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className="border-2 border-green-800 rounded-xl overflow-hidden bg-green-950 bg-opacity-50"
                    >
                        <button
                            onClick={() => toggleFAQ(index)}
                            className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-green-900 transition-colors duration-200"
                        >
                            <span className="font-bold text-base md:text-lg pr-4">
                                {faq.question}
                            </span>
                            <span className="text-2xl md:text-3xl flex-shrink-0">
                                {openIndex === index ? '−' : '+'}
                            </span>
                        </button>

                        <div
                            className={`transition-all duration-300 ease-in-out ${
                                openIndex === index
                                    ? 'max-h-96 opacity-100'
                                    : 'max-h-0 opacity-0'
                            } overflow-hidden`}
                        >
                            <div className="px-6 pb-4 text-base md:text-lg text-gray-200">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
